import styles from "./BlindButton.module.scss"

import React, { useEffect } from "react"

import { scheduleApi } from "@shared/apis"
import { useLayerPopupContext } from "@shared/contexts"

import classNames from "classnames"

interface Props {
  messageKey: string | number | undefined
  scheduleId?: number
  isBlind?: boolean
}

function BlindButton({ messageKey, scheduleId, isBlind }: Props) {
  const {
    open,
    confirm,
    alert: { handleAlert },
  } = useLayerPopupContext()
  const { key, isConfirm } = confirm

  useEffect(() => {
    if (!isConfirm || !scheduleId || messageKey !== key) return

    scheduleApi
      .blind(messageKey, scheduleId)
      .then()
      .catch(({ response }) => {
        const { data } = response
        handleAlert({ contents: data.message })
        open("ALERT")
      })
  }, [key, isConfirm, messageKey, scheduleId, handleAlert, open])

  if (isBlind) {
    return <label>블라인드</label>
  }

  return (
    <button
      className={classNames(styles.blindButton)}
      onClick={() => {
        confirm.handleConfirm({
          key: messageKey,
          message: "블라인드 하시겠습니까?",
          isConfirm: false,
        })
        open("CONFIRM")
      }}
    >
      블라인드
    </button>
  )
}

export default BlindButton
